import { Routes } from '@angular/router';
import { ClientListComponent } from './clients/client-list/client-list.component';
import { ContainerListComponent } from './containers/container-list/container-list.component';
import { ClientCreateComponent } from './clients/client-create/client-create.component';
import { ClientUpdateComponent } from './clients/client-update/client-update.component';
import { ClientDetailComponent } from './clients/client-detail/client-detail.component';
import { ContainerCreateComponent } from './containers/container-create/container-create.component';
import { ContainerUpdateComponent } from './containers/container-update/container-update.component';
import { ContainerTypeListComponent } from './container-types/container-type-list/container-type-list.component';
import { ContainerTypeUpdateComponent } from './container-types/container-type-update/container-type-update.component';
import { ContainerTypeCreateComponent } from './container-types/container-type-create/container-type-create.component';
import { MaintenanceTypeListComponent } from './maintenance-types/maintenance-type-list/maintenance-type-list.component';
import { MaintenanceTypeCreateComponent } from './maintenance-types/maintenance-type-create/maintenance-type-create.component';
import { MaintenanceTypeUpdateComponent } from './maintenance-types/maintenance-type-update/maintenance-type-update.component';
import { DashboardHomeComponent } from './dashboards/dashboard-home/dashboard-home.component';
import { TaskListComponent } from './tasks/task-list/task-list.component';
import { TaskCreateComponent } from './tasks/task-create/task-create.component';
import { TaskUpdateComponent } from './tasks/task-update/task-update.component';
import { AcceptanceCriteriaListComponent } from './acceptance-criterias/acceptance-criteria-list/acceptance-criteria-list.component';
import { AcceptanceCriteriaCreateComponent } from './acceptance-criterias/acceptance-criteria-create/acceptance-criteria-create.component';
import { AcceptanceCriteriaUpdateComponent } from './acceptance-criterias/acceptance-criteria-update/acceptance-criteria-update.component';
import { MaintenanceListComponent } from './maintenances/maintenance-list/maintenance-list.component';
import { MaintenanceCreateComponent } from './maintenances/maintenance-create/maintenance-create.component';
import { MaintenanceUpdateComponent } from './maintenances/maintenance-update/maintenance-update.component';
import { CustomerReportHomeComponent } from './reports/customer/customer-report-home/customer-report-home.component';
import { ContainerReportComponent } from './reports/customer/container-report/container-report.component';
import { TimelineContainerComponent } from './timelines/timeline-container/timeline-container.component';
import { ContainerReportGeneralComponent } from './reports/customer/container-report/container-report-general/container-report-general.component';
import { ContainerReportDetailComponent } from './reports/customer/container-report/container-report-detail/container-report-detail.component';
import { CustomerReportComponent } from './reports/customer/customer-report/customer-report.component';
import { ApprovalNotificationsComponent } from './notifications/approval-notifications/approval-notifications.component';
import { ApprovalNotificationDetailComponent } from './notifications/approval-notification-detail/approval-notification-detail.component';
import { RequesterNotificationsComponent } from './notifications/requester-notifications/requester-notifications.component';
import { RequesterNotificationDetailComponent } from './notifications/requester-notification-detail/requester-notification-detail.component';
import { AlertSettingsComponent } from './notifications/alert-settings/alert-settings.component';
import { CloruroFerricoComponent } from './news/cloruro-ferrico/cloruro-ferrico.component';
import { GeneralComponent } from './news/general/general.component';
import { SalmueraIComponent } from './news/salmuera-i/salmuera-i.component';
import { SalmueraIiComponent } from './news/salmuera-ii/salmuera-ii.component';
import { ComprensionComponent } from './news/comprension/comprension.component';
import { ElectrolizadoresComponent } from './news/electrolizadores/electrolizadores.component';
import { SubestacionComponent } from './news/subestacion/subestacion.component';
import { MovimientoDeProductosComponent } from './news/movimiento-de-productos/movimiento-de-productos.component';
import { DcsComponent } from './news/dcs/dcs.component';
import { DailyShiftComponent } from './news/daily-shift/daily-shift.component';
import { ShiftReportComponent } from './news/shift-report/shift-report.component';
import { HistoricalShiftsComponent } from './news/historical-shifts/historical-shifts.component';
import { HistoricalShiftDetailComponent } from './news/historical-shift-detail/historical-shift-detail.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './core/guards/auth.guard';
import { AppComponent } from './app.component';
import { PreviewComponent } from './news/preview/preview.component';
import { ShiftReportPreviewComponent } from './news/shift-report-preview/shift-report-preview.component';
import { DailyShiftPreviewComponent } from './news/daily-shift-preview/daily-shift-preview.component';
import { MisNovedadesComponent } from './news/mis-novedades/mis-novedades.component';
import { CallbackComponent } from './auth/callback/callback.component';
import { SavedViewsReportComponent } from './reports/saved-views-report/saved-views-report.component';
import { UserManagementComponent } from './news/user-management/user-management.component';
import { UserManagementCreateComponent } from './news/user-management-create/user-management-create.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboards/home',
        loadComponent: () =>
          import('./dashboards/dashboard-home/dashboard-home.component').then((m) => m.DashboardHomeComponent),
      },
      { path: 'clients', component: ClientListComponent },
      { path: 'containers', component: ContainerListComponent },  
      { path: 'containers/create', component: ContainerCreateComponent },
      { path: 'containers/update/:id', component: ContainerUpdateComponent },
      { path: 'clients/create', component: ClientCreateComponent },
      { path: 'clients/detail/:id', component: ClientDetailComponent },
      { path: 'clients/update/:id', component: ClientUpdateComponent },
      { path: 'container-types', component: ContainerTypeListComponent },
      { path: 'container-types/create', component: ContainerTypeCreateComponent },
      { path: 'container-types/update/:id', component: ContainerTypeUpdateComponent },
      { path: 'maintenance-types', component: MaintenanceTypeListComponent },
      { path: 'maintenance-types/create', component: MaintenanceTypeCreateComponent },
      { path: 'maintenance-types/update/:id', component: MaintenanceTypeUpdateComponent },
      { path: 'maintenance-types/update/:id', component: MaintenanceTypeUpdateComponent },
      { path: 'tasks', component: TaskListComponent },
      { path: 'tasks/create', component: TaskCreateComponent },
      { path: 'tasks/update/:id', component: TaskUpdateComponent },
      { path: 'acceptance-criteria', component: AcceptanceCriteriaListComponent },
      { path: 'acceptance-criteria/create', component: AcceptanceCriteriaCreateComponent },
      { path: 'acceptance-criteria/update/:id', component: AcceptanceCriteriaUpdateComponent },
      { path: 'maintenances', component: MaintenanceListComponent },
      { path: 'maintenances/create', component: MaintenanceCreateComponent },
      { path: 'maintenances/update/:id', component: MaintenanceUpdateComponent },
      { path: 'customer-report-home', component: CustomerReportHomeComponent },
      { path: 'container-report', component: ContainerReportComponent },
      { path: 'container-report-general/:id', component: ContainerReportGeneralComponent },
      {
        path: 'container-report-detail/:maintenanceRecordId',
        component: ContainerReportDetailComponent,
      },
      { path: 'customer-report', component: CustomerReportComponent },
      { path: 'saved-views-report', component: SavedViewsReportComponent },
      { path: 'timeline-container/:id', component: TimelineContainerComponent },
      { path: 'approval-notifications', component: ApprovalNotificationsComponent },
      { path: 'requester-notifications', component: RequesterNotificationsComponent },
      { path: 'approval-notification/:id', component: ApprovalNotificationDetailComponent },
      { path: 'requester-notification-detail/:id', component: RequesterNotificationDetailComponent },
      { path: 'alert-settings', component: AlertSettingsComponent },
      { path: 'mis-novedades', component: MisNovedadesComponent },
      { path: 'cloruro-ferrico', component: CloruroFerricoComponent },
      { path: 'salmuera-i', component: SalmueraIComponent },
      { path: 'salmuera-ii', component: SalmueraIiComponent },
      { path: 'comprension', component: ComprensionComponent },
      { path: 'electrolizadores', component: ElectrolizadoresComponent },
      { path: 'subestacion', component: SubestacionComponent },
      { path: 'mov-prod', component: MovimientoDeProductosComponent },
      { path: 'dcs', component: DcsComponent },
      { path: 'news-general', component: GeneralComponent },
      { path: 'daily-shift', component: DailyShiftComponent },
      { path: 'shift-report', component: ShiftReportComponent },
      { path: 'shift-report/:shiftClosureId', component: ShiftReportComponent },
      { path: 'historical-shift', component: HistoricalShiftsComponent },
      { path: 'historical-shift-detail/:shiftClosureId/:tipo', component: HistoricalShiftDetailComponent },
      { path: 'historical-shift-detail/:shiftClosureId/:tipo/:codigo_tipo', component: HistoricalShiftDetailComponent },
      { path: 'preview', component: PreviewComponent },
      { path: 'shift-report-preview', component:  ShiftReportPreviewComponent},
      { path: 'daily-shift-preview', component:  DailyShiftPreviewComponent},
      { path: 'user-management', component:  UserManagementComponent}, 
      { path: 'user-management/create', component:  UserManagementCreateComponent}, 
      { path: 'user-management/read', component:  UserManagementCreateComponent}, 
      { path: 'user-management/edit/:userId/:edit', component:  UserManagementCreateComponent}, 
      
    ],
  },
  { path: 'auth-callback', component: CallbackComponent},
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: 'login' },
  // { path: '', redirectTo: '/dashboards/home', pathMatch: 'full' },
];
